var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilteredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_336_33",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_336_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7999 11.9748L13.3749 10.5498L16.9499 5.9998H8.8249L6.8249 3.9998H18.9999C19.4166 3.9998 19.7166 4.18314 19.8999 4.5498C20.0832 4.91647 20.0499 5.26647 19.7999 5.5998L14.7999 11.9748ZM19.7749 22.5998L13.9999 16.8248V18.9998C13.9999 19.2831 13.9041 19.5206 13.7124 19.7123C13.5207 19.904 13.2832 19.9998 12.9999 19.9998H10.9999C10.7166 19.9998 10.4791 19.904 10.2874 19.7123C10.0957 19.5206 9.9999 19.2831 9.9999 18.9998V12.8248L1.3999 4.2248L2.7999 2.7998L21.1999 21.1998L19.7749 22.5998Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilteredIcon);
export default __webpack_public_path__ + "static/media/filteredIcon.969a1d1f4c3237c1357681362e9fbaa5.svg";
export { ForwardRef as ReactComponent };